import React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import {
  useScheduleData,
  UseScheduleDataReturn,
  getPharmacistAvatarProps,
} from "../scheduleData";

interface PharmacistFilterProps {
  selectedPharmacists: string[];
  onPharmacistChange: (pharmacist: string, checked: boolean) => void;
  onSelectAll: (checked: boolean) => void;
  isDarkMode?: boolean;
}

export function PharmacistFilter({
  selectedPharmacists,
  onPharmacistChange,
  onSelectAll,
  isDarkMode = false,
}: PharmacistFilterProps) {
  const s = useScheduleData();
  const { pharmacists = [] } = (s || {}) as Partial<UseScheduleDataReturn>;

  return (
    <div
      className={`rounded-lg border p-4 transition-colors duration-300 ${
        isDarkMode ? "bg-gray-700 border-gray-600" : "bg-white border-gray-200"
      }`}
    >
      <h4
        className={`text-sm font-semibold mb-3 transition-colors duration-300 ${
          isDarkMode ? "text-white" : "text-gray-900"
        }`}
      >
        Pharmacist
      </h4>
      <div className="space-y-3">
        <div className="flex items-center space-x-2">
          <Checkbox
            id="select-all-pharmacists"
            checked={
              selectedPharmacists.length === pharmacists.length &&
              pharmacists.length > 0
            }
            onCheckedChange={onSelectAll}
          />
          <label
            htmlFor="select-all-pharmacists"
            className={`text-sm cursor-pointer transition-colors duration-300 ${
              isDarkMode ? "text-gray-400" : "text-gray-500"
            }`}
          >
            Select All
          </label>
        </div>
        <hr
          className={`transition-colors duration-300 ${
            isDarkMode ? "border-gray-600" : "border-gray-200"
          }`}
        />
        {pharmacists.map((pharmacist) => {
          const avatarProps = getPharmacistAvatarProps(pharmacist, "md");

          return (
            <div key={pharmacist.id} className="flex items-center space-x-3">
              <Checkbox
                id={`pharmacist-${pharmacist.id}`}
                checked={selectedPharmacists.includes(pharmacist.name)}
                onCheckedChange={(checked) =>
                  onPharmacistChange(pharmacist.name, !!checked)
                }
              />
              {avatarProps.type === "image" ? (
                <img
                  src={avatarProps.src}
                  alt={avatarProps.alt}
                  className={avatarProps.className}
                />
              ) : (
                <div className={avatarProps.className}>
                  {avatarProps.initials}
                </div>
              )}
              <div className="flex flex-col">
                <label
                  htmlFor={`pharmacist-${pharmacist.id}`}
                  className={`text-sm font-medium cursor-pointer transition-colors duration-300 ${
                    isDarkMode ? "text-gray-200" : "text-gray-800"
                  }`}
                >
                  {pharmacist.name}
                </label>
                <span
                  className={`text-xs transition-colors duration-300 ${
                    isDarkMode ? "text-gray-400" : "text-gray-500"
                  }`}
                >
                  {pharmacist.role}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
